import { useEffect, forwardRef, useImperativeHandle, useMemo,useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Text,Container, Stack, Anchor, Checkbox,Divider,Loader, Skeleton } from '@mantine/core';
import { useForm } from "@mantine/form";
import {Row, Col} from 'react-bootstrap';
import { SaveResponses } from "../actions/ResponsesActions";
import { useStepResponses } from "../hooks/useStepResponses";
import useFormTracking from "../hooks/useFormTracking";
import { stepIds } from "../enums/fieldsDataConfig";
import TextPriceWithDiscount from '../components/TextPriceWithDiscount';
import typeConfig from "../config/typeConfig";
import { GetRequerimientosMicrocredencial} from "../actions/CarreraActions";

const ConfirmationForm = forwardRef(({ stepNumber,queryParams,id }, ref) => {

  const dispatch = useDispatch();
  const { checkoutSummary: summary, steps: stepResponses } = useSelector((state) => state.respuestas);
  const knownUser = useSelector((state) => state.respuestas.knownUser);

  const billingResponse = useStepResponses(stepIds.FACTURACION);
  const { track } = useFormTracking(stepNumber);
  const { data: requerimientos, loading: loadingRequerimientos } = useSelector(state => state.carreras.requerimientos);
  const response = stepResponses[stepNumber]?.responses || {};

  useEffect(() => {
    if (queryParams.t === "m") {
      dispatch(GetRequerimientosMicrocredencial());
    }
  }, [queryParams.t]);

  const form = useForm({
    initialValues: {
      aceptaCondiciones: response.aceptaCondiciones || false,
      aceptaRequerimientos: response.aceptaRequerimientos || false,
    },
    validate: {
      aceptaCondiciones: (value) => (value ? null : 'Es necesario aceptar las condiciones'),
      aceptaRequerimientos: (value) => {
        if (queryParams.t !== "m") return null; // está todo bien, no requiere validación
        return value ? null : 'Es necesario aceptar los requerimientos'; // si es true, OK; si es false, error
      }
    },
  });

  useImperativeHandle(ref, () => ({
    validate: () => {
      const validation = form.validate();
      if (validation.hasErrors) {
        Object.keys(validation.errors).forEach((field) =>
          track('field_error', { fieldName: field })
        );
        alert("Debe aceptar los términos para continuar.");
        return false;
      }
      return true;
    },
  }));
  
  useEffect(() => {
    const valuesString = JSON.stringify(form.values);
    dispatch(SaveResponses(id, JSON.parse(valuesString)));
  }, [form.values, dispatch,id ]);

  /*useImperativeHandle(ref, () => ({
    validate: () => {
      const validation = form.validate();
      return !validation.hasErrors;
    },
  }));*/

  return (
    <Container size="90%">
      <Row>
        <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'} style={{display: 'inline-block',borderBottom: '1.5px solid pink',paddingBottom: 2}}>Detalles Programa</Text>
        <Row >
          <Col md={6} lg={5} className="title-description">
            <Text size="sm" c={'rgb(85, 85, 85)'}>{typeConfig[queryParams.t].description}</Text>
            <Text size="lg" fw={500}>{summary.carrera}</Text>
          </Col>
          <Col md={3} lg={4} className="title-description">
            <Text size="sm" c={'rgb(85, 85, 85)'}>Campus</Text>
            <Text size="lg" fw={500}>{summary.campus}</Text>
          </Col>
          <Col md={3} lg={3} className="title-description">
            <Text size="sm" c={'rgb(85, 85, 85)'}>Turno</Text>
            <Text size="lg" fw={500}>{summary.turno}</Text>
          </Col>
        </Row>
      </Row>
      <Row>
        <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'} style={{display: 'inline-block',borderBottom: '1.5px solid pink',paddingBottom: 2 }}>Detalles de Facturación</Text>
        <Row>
          <Col md={3} className="title-description">
            <Text size="sm" c={'rgb(85, 85, 85)'}>Tipo de Facturacion</Text>
            <Text size="md" fw={500}>{billingResponse?.tipoFacturacion}</Text>
          </Col>
          <Col md={3} className="title-description">
            {billingResponse?.tipoFacturacion === 'empresa' ? (
              <>
                <Text size="sm" c={'rgb(85, 85, 85)'}>Empresa</Text>
                <Text size="md" fw={500}>{billingResponse?.razonSocialEmpresa}</Text>
              </>
            ) : (
              <>
                <Text size="sm" c={'rgb(85, 85, 85)'}>Persona</Text>
                <Text size="md" fw={500}>
                  {`${billingResponse?.nombre || ''} ${billingResponse?.apellido || ''}`}
                </Text>
              </>
            )}
          </Col>
          <Col md={4} className="title-description">
            <Text size="sm" c={'rgb(85, 85, 85)'}>Email</Text>
            <Text
              size="md"
              fw={500}
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
                maxWidth: '100%' // Esto asegura que no desborde el Col
              }}
              title={billingResponse?.email} // Al pasar el mouse se ve completo
            >
              {billingResponse?.email}
            </Text>
          </Col>
          <Col md={2} className="title-description">
            <Text size="sm" c={'rgb(85, 85, 85)'}>Teléfono</Text>
            <Text size="md" fw={500}>{billingResponse?.telefono}</Text>
          </Col>
        </Row>
      </Row>
      <Row>
        <Row>
          {queryParams?.t === 'm' ? (
            <>
              <Col md={6} className="title-description">
                <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'} style={{ display: 'inline-block', borderBottom: '1.5px solid pink',paddingBottom: 2 }}>Precio Programa</Text>
              </Col>
              {summary && (
                <TextPriceWithDiscount
                  size='lg'
                  fontWeight={500}
                  price={summary.precioOriginal || 0}
                  discountedPrice={summary.precioDescuento || 0}
                  priceComunityUAI={summary.precioComunidad}
                  isComunidad={knownUser.comunity && summary.precioComunidad != null}
                />
              )}
            </>
          ):(
            <>
              <Col md={12} className="title-description">
                <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'} style={{ display: 'inline-block', borderBottom: '1.5px solid pink',paddingBottom: 2 }}>
                  Precio Matrícula
                </Text>
                <TextPriceWithDiscount
                  size='xl'
                  fontWeight={500}
                  price={summary.precioOriginal || 0}
                  discountedPrice={summary.precioDescuento || 0}
                  priceComunityUAI={summary.precioComunidad}
                  isComunidad={knownUser.comunity && summary.precioComunidad != null}
                />
              </Col>
            </>
          )}
        </Row>
      </Row>
      
      <Row>
        <Stack mt={'xl'} gap="md">
          <Stack spacing="xs">
            <Text size="sm">
              La confirmación de su preinscripción queda sujeta a la validación de la información ingresada.
            </Text>
            <Text size="sm">
              {typeConfig[queryParams.t].confirmationRequiredDocumentation}
            </Text>
            <Text size="sm">
              La apertura de la cursada queda sujeta a contar con un número mínimo de {typeConfig[queryParams.t].minRegistrants} inscriptos.
            </Text>
          </Stack>

          <Checkbox
            color="pink"
            label={
              <Text size="sm">
                Declaro conocer y aceptar las condiciones del{' '}
                <Anchor href="https://nbapi.uai.edu.ar/reglamento-interno/2025/?page=1" target="_blank" underline="hover" c="#f20a61">
                  Reglamento Interno de la Universidad Abierta Interamericana
                </Anchor>.
              </Text>
            }
            required
            {...form.getInputProps("aceptaCondiciones",{ type: 'checkbox' })}
            onChange={(e) => {
              form.setFieldValue('aceptaCondiciones', e.currentTarget.checked);
              if (e.currentTarget.checked) track('field_completed', { fieldName: 'aceptaCondiciones' });
            }}
          />
          {queryParams.t === "m" && (
            <Row>
              <Col md={12}>
                <Skeleton visible={loadingRequerimientos}>
                  <Checkbox
                    color="pink"
                    label={requerimientos || "Debe aceptar los términos"}
                    required
                    {...form.getInputProps("aceptaRequerimientos",{ type: 'checkbox' })}
                    onChange={(e) => {
                      form.setFieldValue('aceptaRequerimientos', e.currentTarget.checked);
                      if (e.currentTarget.checked) track('field_completed', { fieldName: 'aceptaRequerimientos' });
                    }}
                  />
                </Skeleton>
              </Col>
            </Row>
          )}
          <Text size="xs" c="dimmed" style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }}>
            Cabe señalar, que completando el Formulario de Inscripción, autorizo a la Fundación Iberoamericana de Estudios Superiores titular de la Universidad Abierta Interamericana, a utilizar mi imagen, texto, voz y/o testimonio, con fines académicos, así como para la difusión y promoción de sus actividades, siendo esta autorización voluntaria, irrevocable, gratuita y sin límite temporal, renunciando a requerir cualquier tipo de contraprestación o a realizar cualquier reclamo, cediendo entonces a la misma los derechos que le puedan corresponder sobre dicho material y acepta las normativa que derivan de este Reglamento Interno.
          </Text>
        </Stack>
      </Row>
    </Container>
  );
});

export default ConfirmationForm;